<div class="wrap">
    <h2>Ce compte n'existe pas</h2>
    <p>Souhaitez-vous créer un compte avec ces informations ?</p>
    <ul>
        <li>Nom: <strong>{{userSendByFfv?.lastName}}</strong></li>
        <li>Prénom: <strong>{{userSendByFfv?.firstName}}</strong></li>
        <li>Email: <strong>{{userSendByFfv?.email}}</strong></li>
        <li>Licence: <strong>{{userSendByFfv?.licence}}</strong></li>
    </ul>
    <div class="btn_action">
        <button class="back" (click)="dialogRef.close()">non</button>
        <button class="confirm" [mat-dialog-close]="userSendByFfv">oui</button>
    </div>
</div>